// src/ui/HowToPlayModal.ts
//
// Phase 10 — How To Play modal + first-launch helpers.
// Modal is hard to unit-test (Phaser-bound); the helpers are tested directly.

import Phaser from 'phaser';
import { addCrispText } from './textHelper';

export const HOW_TO_PLAY_TEXT = `
HOW TO PLAY ROGUELETTE

GOAL
Beat all 9 rounds across 3 antes by hitting bet targets.

EACH ROUND
- Draw 3 fiches into your tray
- Tap a fiche, then tap a bet area to place it
- Place all 3 fiches and press SPIN
- Repeat for up to 3 spins per round

SCORING
chips x mult x payout per fiche, summed.
Hit the round's target score to clear.

SHOP
After every round, buy fiches, balls, or relics.
Reroll for $1, $2, $3, ...
Skip is free.

BOSS ROUNDS (every 3rd round)
A random modifier blocks bets or halves payouts.
Watch the banner!

WIN by clearing ante 3 boss.
LOSE if you fail any round.

Good luck!
`;

export const FIRST_LAUNCH_KEY = 'roguelette_seen_how_to_play_v1';

export class HowToPlayModal {
  private scene: Phaser.Scene;
  private container: Phaser.GameObjects.Container | null = null;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  open(onClose?: () => void): void {
    if (this.container) return; // already open

    const overlay = this.scene.add
      .rectangle(0, 0, 375, 667, 0x000000, 0.92)
      .setOrigin(0, 0)
      .setDepth(200);
    const panel = this.scene.add
      .rectangle(187, 333, 340, 560, 0x0a3d20)
      .setOrigin(0.5)
      .setStrokeStyle(2, 0xd4af37)
      .setDepth(201);
    const text = addCrispText(this.scene, 187, 333, HOW_TO_PLAY_TEXT.trim(), {
      color: '#ffffff',
      fontSize: '11px',
      align: 'left',
      wordWrap: { width: 320 },
    })
      .setOrigin(0.5)
      .setDepth(202);

    const closeBtn = this.scene.add
      .rectangle(187, 600, 200, 36, 0x064020)
      .setInteractive()
      .setDepth(202);
    const closeLbl = addCrispText(this.scene, 187, 600, 'Close', {
      color: '#ffffff',
      fontSize: '14px',
    })
      .setOrigin(0.5)
      .setDepth(203);

    this.container = this.scene.add
      .container(0, 0, [overlay, panel, text, closeBtn, closeLbl])
      .setDepth(200);

    closeBtn.on('pointerdown', () => {
      this.close();
      onClose?.();
    });
  }

  close(): void {
    if (this.container) {
      this.container.destroy();
      this.container = null;
    }
  }

  isOpen(): boolean {
    return this.container !== null;
  }
}

export function isFirstLaunch(): boolean {
  try {
    return localStorage.getItem(FIRST_LAUNCH_KEY) === null;
  } catch {
    return false;
  }
}

export function markFirstLaunchSeen(): void {
  try {
    localStorage.setItem(FIRST_LAUNCH_KEY, '1');
  } catch {
    // noop
  }
}
